import { User } from '@arpeggi/shared'
import { PropsWithChildren } from 'react'
import { styled } from '../../../lib/stitches'
import { Box } from '../../core/Components'
import { FieldErrorLabel } from '../../core/FieldErrorLabel'
import { FieldLabel } from '../../core/FieldLabel'
import { Flex } from '../../core/Flex'
import Text from '../../core/Text/Text'
import { gray4 } from '../../platform/color'

export const StyledContainer = styled('div', {
  margin: 'auto',
  maxWidth: '1900px',
  padding: '30px 20px'
})

export const TableHeader: React.FC<PropsWithChildren> = ({ children }) => (
  <Text size="18" fontWeight="bold">
    {children}
  </Text>
)

export const TableRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  padding: '13px 0px',
  borderBottomColor: gray4,
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  '& > div': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '16px',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    display: 'flex',
    flex: 1
  },
  variants: {
    hover: {
      true: {
        '&:hover': {
          backgroundColor: '$gray02',
          cursor: 'pointer',
          transition: 'background-color 0.25s ease'
        }
      }
    }
  }
})

export const TableText: React.FC<PropsWithChildren> = ({ children }) => (
  <Text size="14">{children}</Text>
)

export const UserDetails: React.FC<{ user: User }> = ({ user }) => (
  <Flex direction="column" css={{ gap: '16px' }}>
    <Text size="16">Wallet address: {user.walletAddress}</Text>
    <Text size="16">Display name: {user.displayName}</Text>
  </Flex>
)

export const FileUpload: React.FC<{
  fieldName: string
  label: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  errorMessage?: string
  imagePreviewUrl?: string
  audioPreviewUrl?: string
  acceptedFiles?: string[]
}> = ({
  fieldName,
  label,
  onChange,
  errorMessage,
  imagePreviewUrl,
  acceptedFiles,
  audioPreviewUrl
}) => (
  <Flex css={{ marginBottom: '$10', flexDirection: 'column' }}>
    <FieldLabel htmlFor={fieldName}>{label}</FieldLabel>
    <input
      type="file"
      accept={acceptedFiles?.join(',')}
      id={fieldName}
      placeholder={fieldName}
      onChange={onChange}
    />
    <FieldErrorLabel css={{ marginTop: '8px', marginBottom: '8px' }}>
      {errorMessage}
    </FieldErrorLabel>
    {imagePreviewUrl && (
      <Box
        css={{
          aspectRatio: 3 / 2,
          borderRadius: '$8',
          backgroundImage: `url(${imagePreviewUrl})`,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          maxWidth: '400px'
        }}
      />
    )}
    {audioPreviewUrl && (
      <audio controls>
        <source src={audioPreviewUrl} />
      </audio>
    )}
  </Flex>
)

export const Badge = styled('div', {
  backgroundColor: '$background__primary',
  padding: '4px',
  fontSize: '$10',
  borderRadius: '$8',
  marginLeft: '8px'
})
